import { Palette } from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';

const fallbackFonts = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
];

export const fontFamily = ['"Mona Sans"', ...fallbackFonts].join(',');
export const headingFontFamily = ['"Youth"', ...fallbackFonts].join(',');

/** Bare font sizes, for text that isn't one of the variants below. */
export const fontSizes = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '21px',
  display: '28px',
} as const;

export const typography = (palette: Palette): TypographyOptions => ({
  fontFamily,
  h1: {
    fontFamily: headingFontFamily,
    textTransform: 'uppercase',
    fontSize: fontSizes.display,
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: fontSizes.xl,
    fontWeight: 600,
    lineHeight: 1.25,
  },
  h3: {
    fontSize: fontSizes.lg,
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h4: {
    fontSize: fontSizes.md,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h5: {
    fontSize: fontSizes.md,
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h6: {
    fontSize: fontSizes.sm,
    fontWeight: 700,
    lineHeight: 1.3,
  },
  subtitle1: {
    fontSize: fontSizes.md,
    fontWeight: 500,
    lineHeight: 1.4,
  },
  subtitle2: {
    fontSize: fontSizes.sm,
    fontWeight: 700,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: fontSizes.sm,
    fontWeight: 400,
    lineHeight: 1.5,
    color: palette.text.primary,
  },
  body2: {
    fontSize: fontSizes.sm,
    fontWeight: 400,
    lineHeight: 1.5,
    color: palette.text.secondary,
  },
  caption: {
    fontSize: fontSizes.xs,
    fontWeight: 400,
    lineHeight: 1.4,
    color: palette.text.secondary,
  },
  overline: {
    fontSize: fontSizes.xs,
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    color: palette.text.secondary,
  },
  statValue: {
    fontSize: fontSizes.display,
    fontWeight: 700,
    lineHeight: 1.15,
  },
});
